import React, { useState, useContext, useEffect, useRef } from 'react';
// AXIOS
import axios from 'axios';

export function useHelpers() {
    useEffect(() => {
    }, []);

    const geocode_point = (address) => {
        // return axios.get(window.GMAPS_GEOCODE_URL+'address='+address+'&key='+window.GMAPS_APIKEY);
        return axios.get("https://backend.ophygas.it/api/optimo/geocode_address?address="+address);

    }

    return { geocode_point};
}